export default {
  theme: 'colored',
  position: 'top-right',
  autoClose: 2000,
  pauseOnHover: false,
  closeOnClick: true
};
